export const parseMessage = (
  text: string,
  navigate: (path: string, options: { state: { id: string } }) => void
) => {
  const linkRegex = /\[link:(.*?):(.*?)\]/g;
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let i = 0;
  while ((match = linkRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    i++;

    const displaytext = match[1];
    let nav = match[2].split("^")[0];
    let ID = match[2].split("^")[1] ? match[2].split("^")[1] : "";
    let msgID = "";
    if (displaytext === "Click to view") {
      msgID = match[2].split("^")[2] ? match[2].split("^")[2] : "";
    }
    parts.push(
      <div
        key={i}
        className="text-light-purple text-decoration-none d-inline cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          if (displaytext === "Click to view") {
            localStorage.setItem("messageId", msgID);
          }
          navigate(`/${nav}`, { state: { id: ID } });
        }}
      >
        {match[1]}
      </div>
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};
